/**
 * Shopify Storefront API Client
 * This file initializes the Shopify Storefront API client using environment variables
 */

import { IShopifyConfig, IShopifyStorefrontClient } from "./interface";
import { createStorefrontApiClient } from "@shopify/storefront-api-client";

export function createShopifyStorefrontClient(
  config: IShopifyConfig
): IShopifyStorefrontClient {
  const { domain, storefrontAccessToken, apiVersion = "2025-04" } = config;

  // Create the native Shopify Storefront API client
  const nativeClient = createStorefrontApiClient({
    storeDomain: domain,
    apiVersion: apiVersion,
    publicAccessToken: storefrontAccessToken,
  });

  // Adapt the native client to our interface
  return {
    request: <T>(query: string, variables?: Record<string, any>) => {
      return nativeClient.request<T>(query, variables);
    },
  };
}
